import BaseLayout from '@/components/PageLayout';
import '@elem/compBlog/blog.scss';
import BlogCategoryItems from '@elem/compBlog/category';
import { queryEditorDetailBlogOnline } from 'lowcode/utils/service';
import { queryCategoryItems } from 'lowcomp/plugins/blog/common/blog-api/queryCategoryItems';

export default function Page({ tempData, locale, id, categoryId, categoryData }: any) {
    return (
        <BaseLayout>
            <BlogCategoryItems categoryId={categoryId} categoryData={categoryData} />
        </BaseLayout>
    );
}

export async function getServerSideProps({ params, locale }: any) {
    const categoryId = params.id;
    const id1 = params.id[0];
    const id = `/${locale}/author/category/${id1}`;
    const tempData: any = await queryEditorDetailBlogOnline(id, locale);
    const categoryData = await queryCategoryItems(locale, {
        categoryId: categoryId[0],
    });

    return {
        props: {
            tempData,
            locale,
            id,
            categoryId,
            categoryData,
        },
    };
}
